import React from 'react';
import { useHomeDetailsContext } from '../contexts/HomeDetailsContext';
import { HomeIntelligenceProvider } from '../contexts/HomeIntelligenceContext';
import { extractAddressFromDetails } from '../utils/homeUtils';
import { IntelligenceErrorBoundary } from './intelligence/IntelligenceErrorBoundary';

interface HomeDetailsWithIntelligenceProps {
  children: React.ReactNode;
}

/**
 * Wrapper component that provides intelligence context with address extracted from home details
 */
export const HomeDetailsWithIntelligence: React.FC<HomeDetailsWithIntelligenceProps> = ({
  children,
}) => {
  const { homeData } = useHomeDetailsContext();

  // Extract address from home details
  const address = extractAddressFromDetails(homeData?.details || '');

  return (
    <HomeIntelligenceProvider address={address} enabled={!!address}>
      <IntelligenceErrorBoundary>
        {children}
      </IntelligenceErrorBoundary>
    </HomeIntelligenceProvider>
  );
};

export default HomeDetailsWithIntelligence;